export default "__VITE_ASSET__cd0e6d9a__"